const headers = {
  name: "Expense categories",
  navigate: {
    path: [
      {
        name: "Categories",
        path: "/app/expenses/categories",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
